import { Box, Grid, Paper, Stack } from '@mui/material';
import React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../helpers/Notification';
import { LoadingWidget } from '../../widgets';
import { getFilesArchivos } from '../archivos/HelpersArchivos';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { saveCarnetAction } from './CarnetAction';
import useCarnetHook from './CarnetHook';
import jsonStyles from './StylesCarnet.json';
import ButtonsVerticalCarnet from './components/ButtonVertical';
import FormStylesCarnet from './components/FormStylesCarnet';
import FrontalCarnet from './components/FrontalCarnet';
import LayoutCarnet from './components/LayoutCarnet';
import ReverseCarnet from './components/ReserveCarnet';

const CarnetAjustesView = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const { entidad, activo, styles, params } = useCarnetHook();
  const [loadingSave, setLoadingSave] = React.useState(false);

  const {
    titleText,
    subtitleText,
    titleSeccionText,
    titleNivelText,
    titleAgeText,
    titleBackText,
    subtitleBackText,
    perfil,
    titleFirmaText,
    parametro1,
    parametro2,
  } = activo;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Stack direction="row" spacing={2}>
            <Paper
              elevation={4}
              sx={{
                p: 2,
                maxHeight: '75vh',
                overflow: 'scroll',
                width: '280px',
              }}
            >
              <ButtonsVerticalCarnet activo={activo} id={styles?.id} />
            </Paper>
            {styles && (
              <Paper
                elevation={4}
                sx={{
                  p: 2,
                  maxHeight: '75vh',
                  overflow: 'scroll',
                  width: '400px',
                }}
              >
                <FormStylesCarnet component="title" />
              </Paper>
            )}
          </Stack>
          <Box>
            <LoadingWidget isLoading={loadingSave} pb={1} />
            <Stack direction="row" spacing={2}>
              <LayoutCarnet
                bg={
                  getFilesArchivos(activo.fondo)
                    ? getFilesArchivos(activo.fondo)
                    : null
                }
              >
                <FrontalCarnet
                  data={{
                    titleText,
                    subtitleText,
                    titleSeccionText,
                    titleNivelText,
                    titleAgeText,
                    titleBackText,
                    subtitleBackText,
                    parametro1,
                    parametro2,
                    surnames: 'APELLIDOS DEL USUARIO',
                    profile: perfil.nombre,
                  }}
                />
              </LayoutCarnet>
              <LayoutCarnet
                bg={
                  activo.fondoBack ? getFilesArchivos(activo.fondoBack) : null
                }
              >
                <ReverseCarnet
                  data={{
                    titleBackText,
                    subtitleBackText,
                    titleFirmaText,
                  }}
                />
              </LayoutCarnet>
            </Stack>
            <center>
              <BotonComponent
                click={async () => {
                  if (!entidad) {
                    notify('Falta seleccionar la entidad', { warning: true });
                    return;
                  }
                  setLoadingSave(true);

                  const listStyles = {};
                  Object.keys(jsonStyles).map(
                    (key) => (listStyles[key] = activo[key]),
                  );

                  await saveCarnetAction(
                    { dispatch, notify },
                    activo.id,
                    {
                      idEntidad: entidad.id,
                      nombre: activo.nombre,
                      idPerfil: activo.perfil.id,
                      titleText: activo.titleText,
                      subtitleText: activo.subtitleText,
                      titleBackText: activo.titleBackText,
                      subtitleBackText: activo.subtitleBackText,
                      titleSeccionText: activo.titleSeccionText,
                      titleNivelText: activo.titleNivelText,
                      titleAgeText: activo.titleAgeText,
                      idLogoLeft: activo.logoLeft?.id,
                      idLogoRight: activo.logoRight?.id,
                      idLogoLeftBack: activo.logoLeftBack?.id,
                      idLogoRightBack: activo.logoRightBack?.id,
                      idFondo: activo.londo?.id,
                      idFondoBack: activo.londoBack?.id,
                      idFirma: activo.lirma?.id,
                      titleFirmaText: activo.titleFirmaText,
                      parametro1: activo.parametro1,
                      parametro2: activo.parametro2,
                      ...listStyles,
                    },
                    params,
                  );
                  setLoadingSave(false);
                }}
                text="GUARDAR"
                disabled={loadingSave}
                green
                saveIcon
                mt={2}
              />
            </center>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CarnetAjustesView;
